import { UrlSorting } from '@components/modules/ProductGrid/Sorting/sorting'
import { SortedCustomProductGridTile } from './hooks/productGrid/useSortedProducts'

export const clientSideSort = (
  a: SortedCustomProductGridTile,
  b: SortedCustomProductGridTile,
  sortBy?: UrlSorting,
) => {
  if (!sortBy) return 0

  const getPrice = (product: SortedCustomProductGridTile) => {
    //find cheapest variant
    const prices = product.variants.map(
      (variant) => variant.price?.value.centAmount,
    )
    return Math.min(...prices)
  }

  switch (true) {
    case sortBy.field == 'name' && sortBy.direction === 'ASC':
      return a.name > b.name ? 1 : -1
    case sortBy.field == 'name' && sortBy.direction === 'DESC':
      return a.name > b.name ? -1 : 1
    case sortBy.field == 'price' && sortBy.direction == 'ASC':
      return getPrice(a) == getPrice(b) ? 0 : getPrice(a) < getPrice(b) ? -1 : 1
    case sortBy.field == 'price' && sortBy.direction == 'DESC':
      return getPrice(a) == getPrice(b) ? 0 : getPrice(a) < getPrice(b) ? 1 : -1
    default:
      break
  }
  return 0
}
